/**
 * Created by ws7 on 2017/6/12.
 */


import * as commonConst from '../common/constants';
import * as snapConst from './constants';
import * as snapApis from '../../services/apis/snap';
import Vue from 'vue';

export default {
    [snapConst.getSnaps](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeLocalVolumeSnapshots);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.msg) {
                    reject(data.msg)
                } else {
                    ctx.commit(snapConst.getSnaps, data);
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.getDataDiskSnaps](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeLocalVolumeSnapshots);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (data.msg) {
                    reject(data.msg)
                } else {
                    ctx.commit(snapConst.getDataDiskSnaps, data);
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.DescribeSnapshots](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeSnapshots);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (data.msg) {
                    reject(data.msg)
                } else {
                    ctx.commit(snapConst.DescribeSnapshots, data);
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.getAllSnaps](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeLocalVolumeSnapshots);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if (data.msg) {
                    reject(data.msg)
                } else {
                    resolve(data);
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.deleteSnaps](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DeleteSnaps);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);

                // data = _.get(data, 'ReturnSet');
                // if(_.every(data, (item) => {
                //     return item.Return == true
                // })) {
                //     // resolve();
                // } else {
                //     let errorArray = _.map(_.filter(data, function (item) {
                //         return item.Return == false
                //     }), 'LocalVolumeSnapshotId');
                //     reject(errorArray + ' ' + Vue.$trans(`删除失败`))
                // }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.rollbackSnaps](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.rollbackSnaps);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                // resolve(data);
                if(data.Return == true) {
                    resolve();
                } else {
                    reject(Vue.$trans(`回滚失败`))
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.ModifyLocalVolumeSnapshot](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.ModifyLocalVolumeSnapshot);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                if(data.Return == true) {
                    resolve(data);
                } else {
                    reject(data);
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.DescribeSnapshotUsageHistory](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeSnapshotUsageHistory);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.DescribeSnapshotChains](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeSnapshotChains);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.DescribeSnapshotsOfChain](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeSnapshotsOfChain);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.DescribeSnapshotChainTotalSize](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeSnapshotChainTotalSize);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.CopySnapshot](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.CopySnapshot);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data)
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.ModifySnapshotScheduledTime](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.ModifySnapshotScheduledTime);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [snapConst.DescribeLocalVolumeSnapshots](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, snapApis.DescribeLocalVolumeSnapshots);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    }
    
};

